import React, { useEffect, useMemo, useRef, useState } from "react";
import jwtDecode from "jwt-decode";
import CustomIcons from "../../../components/icons/kIcons.component";
import Loader from "../../../components/loader/loader";
import SearchButton from "../../../components/inputs/searchButton";
import { user_company_users_list, user_company_users_create, user_company_users_update, user_company_users_delete } from "../user.api";
import "./compDirectory.style.css";
import BreadCrumpBack from "../../../components/navigator/back";
import Swal from "sweetalert2";

export default function CompanyUsersDirectory(props) {
  const [pageSize, setPageSize] = useState(6);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [search, setSearch] = useState("");
  const [qsearch, setQsearch] = useState("");
  const [openView, setOpenView] = useState(false);
  const [activeData, setActiveData] = useState({});
  const [openCreate, setOpenCreate] = useState(false);
  const [createFormData, setCreateFormData] = useState({
    name: '',
    email: '',
    mobile_number: '',
    role: ''
  });
  const [createLoading, setCreateLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [viewUserData, setViewUserData] = useState({});
  const myRef = useRef(null);
  const [formErrors, setFormErrors] = useState({
    email: '',
    mobile_number: ''
  });
  const isLoggedIn = Boolean(
    props?.state?.payload ||
    localStorage.getItem("token") ||
    localStorage.getItem("payload") ||
    sessionStorage.getItem("token") ||
    sessionStorage.getItem("payload")
  );
  
  // Check if user is a company user (user_type 4)
  const isCompanyUser = () => {
    const token = props?.state?.payload || localStorage.getItem("token") || sessionStorage.getItem("token");
    if (!token) return false;
    
    try {
      const decoded = jwtDecode(token);
      return decoded.user?.user_type === 0 || decoded.user?.user_type === 4 || decoded.user?.user_type === 5 || decoded.user?.user_type === 6;
    } catch (error) {
      return false;
    }
  };
  const filteredData = useMemo(() => {
    if (!qsearch) return data;
    return data.filter(user =>

        
      user.name?.toLowerCase().includes(qsearch.toLowerCase()) ||
      user.email?.toLowerCase().includes(qsearch.toLowerCase()) ||
      user.role?.toLowerCase().includes(qsearch.toLowerCase())
    );
  }, [data, qsearch]);
  const mainData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return filteredData.slice(firstPageIndex, lastPageIndex);
  }, [filteredData, currentPage, pageSize]);

  const listData = () => {
    setIsActive(true);
    user_company_users_list().then((res) => {
      let dir = res.data || [];
      setData(dir);
      setIsActive(false);
    }).catch((error) => {
      console.error("Error fetching company users:", error);
      setIsActive(false);
    });
  };

  useEffect(() => {
    listData();
  }, []);

  // Responsive page size
  useEffect(() => {
    const computeSize = () => {
      const isLarge = typeof window !== 'undefined' && window.innerWidth >= 1025;
      setPageSize(isLarge ? 6 : 6);
    };
    computeSize();
    window.addEventListener('resize', computeSize);
    return () => window.removeEventListener('resize', computeSize);
  }, []);

  const searchChange = (e) => {
    const v = e.target.value;
    setSearch(v);
    setQsearch(v);
  };

  const submitSearch = () => {
    setQsearch(search);
  };

  const clearSearch = () => {
    setSearch("");
    setQsearch("");
  };

  const handleViewDetails = (item) => {
    setOpenView(true);
    setActiveData(item);
  };

  const handleViewClose = () => {
    setOpenView(false);
    setViewUserData({});
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    myRef.current.scrollIntoView();
  };

  const handleCreateOpen = () => {
    setIsEditMode(false);
    setEditingUserId(null);
    setOpenCreate(true);
    setCreateFormData({
      name: '',
      email: '',
      mobile_number: '',
      role: ''
    });
  };

  const handleEditOpen = (user) => {
    setIsEditMode(true);
    setEditingUserId(user.id);
    setOpenCreate(true);
    setCreateFormData({
      name: user.name || '',
      email: user.email || '',
      mobile_number: user.mobile_number || '',
      role: user.role || ''
    });
  };

  const handleDeleteUser = (user) => {
    Swal.fire({
      title: props.state.language === "ma" ? "ഉറപ്പാണോ?" : "Are you sure?",
      text: props.state.language === "ma"
        ? `${user.name} എന്ന ഉപയോക്താവിനെ ഇല്ലാതാക്കാൻ നിങ്ങൾക്ക് ഉറപ്പാണോ?`
        : `Are you sure you want to delete user ${user.name}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: props.state.language === "ma" ? "ഇല്ലാതാക്കുക" : "Delete",
      cancelButtonText: props.state.language === "ma" ? "റദ്ദാക്കുക" : "Cancel"
    }).then((result) => {
      if (result.isConfirmed) {
        user_company_users_delete(user.id)
          .then((res) => {
            listData(); // Refresh the list
            Swal.fire({
              icon: "success",
              title: props.state.language === "ma" ? "ഇല്ലാതാക്കി!" : "Deleted!",
              text: props.state.language === "ma"
                ? "ഉപയോക്താവ് വിജയകരമായി ഇല്ലാതാക്കി"
                : "User has been deleted successfully"
            });
          })
          .catch((error) => {
            console.error("Error deleting company user:", error);
            Swal.fire({
              icon: "error",
              title: props.state.language === "ma" ? "പിശക്!" : "Error!",
              text: props.state.language === "ma"
                ? "ഉപയോക്താവിനെ ഇല്ലാതാക്കുന്നതിൽ പിശക്"
                : "Failed to delete user"
            });
          });
      }
    });
  };

  const handleViewUser = (user) => {
    setViewUserData(user);
    setOpenView(true);
  };

  const handleCreateClose = () => {
    setOpenCreate(false);
    setIsEditMode(false);
    setEditingUserId(null);
    setCreateFormData({
      name: '',
      email: '',
      mobile_number: '',
      role: ''
    });
  };

  const handleCreateInputChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    // Allow only digits for mobile_number and limit to 10 characters
    if (name === 'mobile_number') {
      value = value.replace(/[^0-9]/g, '').slice(0, 10);
    }

    setCreateFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Validation
    let error = '';

    if (name === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (value && !emailRegex.test(value)) {
        error = 'Invalid email format';
      }
    }

    if (name === 'mobile_number') {
      const phoneRegex = /^[0-9]{10}$/; // 10 digit number
      if (value && !phoneRegex.test(value)) {
        error = 'Mobile number must be 10 digits';
      }
    }

    setFormErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };
  const handleCreateSubmit = (e) => {
    e.preventDefault();
    setCreateLoading(true);

    const apiCall = isEditMode
      ? user_company_users_update(editingUserId, createFormData)
      : user_company_users_create(createFormData);

    const successMessage = isEditMode
      ? (props.state.language === "ma" ? "ഉപയോക്താവ് വിജയകരമായി അപ്ഡേറ്റ് ചെയ്തു" : "User updated successfully")
      : (props.state.language === "ma" ? "ഉപയോക്താവ് വിജയകരമായി സൃഷ്ടിച്ചു" : "User created successfully");

    const errorMessage = isEditMode
      ? (props.state.language === "ma" ? "ഉപയോക്താവ് അപ്ഡേറ്റ് ചെയ്യുന്നതിൽ പിശക്" : "Failed to update user")
      : (props.state.language === "ma" ? "ഉപയോക്താവ് സൃഷ്ടിക്കുന്നതിൽ പിശക്" : "Failed to create user");

    apiCall
      .then((res) => {
        setCreateLoading(false);
        handleCreateClose();
        listData(); // Refresh the list

        // Show success popup using SweetAlert2
        Swal.fire({
          icon: "success",
          title: props.state.language === "ma" ? "വിജയകരമായി!" : "Success!",
          text: successMessage
        });
      })
      .catch((error) => {
        console.error(`Error ${isEditMode ? 'updating' : 'creating'} company user:`, error);
        setCreateLoading(false);
        // Try to extract backend validation error (e.g., email already taken)
        let backendError = "";
        const resp = error?.response?.data;

        if (resp?.message && typeof resp.message === "string") {
          backendError = resp.message;
        }

        if (!backendError && resp?.errors && typeof resp.errors === "object") {
          const firstFieldErrors = Object.values(resp.errors)[0];
          if (Array.isArray(firstFieldErrors) && firstFieldErrors.length > 0) {
            backendError = firstFieldErrors[0];
          }
        }

        // Fallback to generic errorMessage if no specific backend error found
        const finalMessage = backendError || errorMessage;

        // Show error popup using SweetAlert2
        Swal.fire({
          icon: "error",
          title: props.state.language === "ma" ? "പിശക്!" : "Error!",
          text: finalMessage,
        });
      });
  };

  // Filter data based on search


  return (
    <div ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="header-banner">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "കമ്പനി ഉപയോക്താക്കൾ"
              : "Company Users"}
          </div>
        </div>
      </div>
      <BreadCrumpBack />

      <div className="comp-top-wrap">
        {/* Search bar */}
        <div className="top-filter-wrap">
          <div className="filter-bar-actions">
            <div className="comp-search-box">
              <SearchButton
                type="text"
                onChange={searchChange}
                clearSearch={clearSearch}
                value={search}
                placeholder="Search by name, email, or role"
                showSearchIcon={false}
              />
            </div>
            {isCompanyUser() && (
              <button
                className="create-user-btn"
                onClick={handleCreateOpen}
              >
                <CustomIcons iconName="add" iconClass="btn-icon" />
                {props.state.language === "ma" ? "ഉപയോക്താവ് ചേർക്കുക" : "Add User"}
              </button>
            )}
          </div>
        </div>

        {/* Listing */}
        <div className="comp-outer-cont">
          <div className="com-dir-cont">
            <div className="comp-list-con">
              {mainData && mainData.length !== 0 ? (
                <>
                  {mainData?.map((item) => (
                    <div key={item.id} className="comp-list-item-cont">
                      <div className="comp-list-item">
                        <div className="comp-item-comp-title">
                          {(() => {
                            const name = item.name;
                            if (!name || typeof name !== "string") return name || "N/A";
                            return name.charAt(0).toUpperCase() + name.slice(1);
                          })()}
                        </div>
                        <div className="comp-item-header">
                          <div className="comp-item-logo">
                            {item.name ? item.name.substring(0, 1).toUpperCase() : "U"}
                          </div>
                          <div className="comp-item-header-data">
                            <div className="comp-item-person-name">
                              {item.role || "N/A"}
                            </div>

                            <div className="d-flex">
                              <div>
                                <CustomIcons
                                  iconName="mail"
                                  iconClass="comp-item-data-icons"
                                />
                              </div>
                              <div className="text-break">
                                {item.email || "N/A"}
                              </div>
                            </div>

                            {item.mobile_number && (
                              <div className="d-flex">
                                <div>
                                  <CustomIcons
                                    iconName="phone"
                                    iconClass="comp-item-data-icons"
                                  />
                                </div>
                                <div className="text-break">
                                  {item.mobile_number}
                                </div>
                              </div>
                            )}

                            <div className="d-flex mt-2 ">
                              <div>
                                <CustomIcons
                                  iconName="status"
                                  iconClass="comp-item-data-icons"
                                />
                              </div>
                              {/* <div className="text-break">
                                <span className={`status-badge ${item.status === 1 ? 'badge-success' : 'badge-secondary'}`}>
                                  {item.status === 1 ? 'Active' : 'Inactive'}
                                </span>
                              </div> */}
                            </div>
                          </div>
                        </div>

                        {/* Status and role chips */}
                        {/* <div className="comp-item-dom-cont" style={{ marginTop: 10 }}>
                          <span className="chip">#{item.role || 'No Role'}</span>
                          <span className={`chip ${item.status === 1 ? 'chip-active' : 'chip-inactive'}`}>
                            {item.status === 1 ? 'Active' : 'Inactive'}
                          </span>
                        </div> */}

                        <div className="comp-item-product-prof-cont">
                          <b>Account Information</b>
                          <div className="comp-item-prod-prof-title">
                            Created: {item.created_at ? new Date(item.created_at).toLocaleDateString('en-GB') : 'N/A'}
                          </div>
                          <div className="comp-item-prod-prof-title">
                            Last Login: {item.last_login_at ? new Date(item.last_login_at).toLocaleDateString('en-GB') : 'Never'}
                          </div>
                        </div>

                        {isCompanyUser() && (
                          <div className="comp-view-more-cont">
                            {/* <div
                              className="comp-item-view-btn"
                              onClick={() => handleViewUser(item)}
                            >
                              <CustomIcons iconName="view" iconClass="view-icon" />
                            </div> */}
                            <div
                              className="comp-item-update-btn"
                              onClick={() => handleEditOpen(item)}
                            >
                              <CustomIcons iconName="edit" iconClass="edit-icon" />
                            </div>
                            <div
                              className="comp-item-delete-btn"
                              onClick={() => handleDeleteUser(item)}
                            >
                              <CustomIcons iconName="delete" iconClass="delete-icon" />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </>
              ) : (
                <div className="no-data-found">No Results found</div>
              )}
            </div>
          </div>
        </div>

        {/* Pagination */}
        {filteredData.length > pageSize && (
          <div className="pagination-container">
            <div className="pagination-info">
              Showing {((currentPage - 1) * pageSize) + 1} to {Math.min(currentPage * pageSize, filteredData.length)} of {filteredData.length} entries
            </div>
            <div className="pagination-controls">
              <button
                className="pagination-btn"
                disabled={currentPage === 1}
                onClick={() => handlePageChange(currentPage - 1)}
              >
                Previous
              </button>
              <span className="pagination-current">
                Page {currentPage} of {Math.ceil(filteredData.length / pageSize)}
              </span>
              <button
                className="pagination-btn"
                disabled={currentPage === Math.ceil(filteredData.length / pageSize)}
                onClick={() => handlePageChange(currentPage + 1)}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Create User Modal */}
      {openCreate && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header modal-header-white">
              <h2>
                {isEditMode
                  ? (props.state.language === "ma" ? "ഉപയോക്താവ് അപ്ഡേറ്റ് ചെയ്യുക" : "Update User")
                  : (props.state.language === "ma" ? "പുതിയ ഉപയോക്താവ് ചേർക്കുക" : "Add New User")
                }
              </h2>
              <button className="modal-close-btn" onClick={handleCreateClose}>
                <CustomIcons iconName="close" iconClass="close-icon" />
              </button>
            </div>

            <form onSubmit={handleCreateSubmit} className="create-user-form">
              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "പേര്" : "Name"} <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={createFormData.name}
                  onChange={handleCreateInputChange}
                  required
                  placeholder={props.state.language === "ma" ? "പേര് നൽകുക" : "Enter name"}
                />
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "ഇമെയിൽ" : "Email"} <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={createFormData.email}
                  onChange={handleCreateInputChange}
                  required
                  placeholder={props.state.language === "ma" ? "ഇമെയിൽ നൽകുക" : "Enter email"}
                />
                {formErrors.email && (
                  <div className="error-text">{formErrors.email}</div>
                )}
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "മൊബൈൽ നമ്പർ" : "Mobile Number"}
                </label>
                <input
                  type="tel"
                  name="mobile_number"
                  value={createFormData.mobile_number}
                  onChange={handleCreateInputChange}
                  placeholder={props.state.language === "ma" ? "മൊബൈൽ നമ്പർ നൽകുക" : "Enter mobile number"}
                />
                {formErrors.mobile_number && (
                  <div className="error-text">{formErrors.mobile_number}</div>
                )}
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "റോൾ" : "Role"} <span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  name="role"
                  value={createFormData.role}
                  onChange={handleCreateInputChange}
                  required
                  placeholder={props.state.language === "ma" ? "റോൾ നൽകുക" : "Enter role"}
                />
              </div>

              <div className="form-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={handleCreateClose}
                  disabled={createLoading}
                >
                  {props.state.language === "ma" ? "റദ്ദാക്കുക" : "Cancel"}
                </button>
                <button
                  type="submit"
                  className="btn-submit"
                  disabled={createLoading}
                >
                  {createLoading
                    ? (isEditMode
                      ? (props.state.language === "ma" ? "അപ്ഡേറ്റ് ചെയ്യുന്നു..." : "Updating...")
                      : (props.state.language === "ma" ? "സൃഷ്ടിക്കുന്നു..." : "Creating...")
                    )
                    : (isEditMode
                      ? (props.state.language === "ma" ? "അപ്ഡേറ്റ് ചെയ്യുക" : "Update")
                      : (props.state.language === "ma" ? "സൃഷ്ടിക്കുക" : "Create")
                    )
                  }
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* View User Modal */}
      {openView && (
        <div className="modal-overlay">
          <div className="modal-container">
            <div className="modal-header modal-header-white">
              <h2>
                {props.state.language === "ma" ? "ഉപയോക്താവിന്റെ വിവരങ്ങൾ" : "User Details"}
              </h2>
              <button className="modal-close-btn" onClick={handleViewClose}>
                <CustomIcons iconName="close" iconClass="close-icon" />
              </button>
            </div>

            <div className="view-user-form">
              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "പേര്" : "Name"}
                </label>
                <div className="form-value">{viewUserData.name || "N/A"}</div>
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "ഇമെയിൽ" : "Email"}
                </label>
                <div className="form-value">{viewUserData.email || "N/A"}</div>
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "മൊബൈൽ നമ്പർ" : "Mobile Number"}
                </label>
                <div className="form-value">{viewUserData.mobile_number || "N/A"}</div>
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "റോൾ" : "Role"}
                </label>
                <div className="form-value">{viewUserData.role || "N/A"}</div>
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "നില" : "Status"}
                </label>
                <div className="form-value">
                  <span className={`badge ${viewUserData.status === 1 ? 'badge-success' : 'badge-secondary'}`}>
                    {viewUserData.status === 1
                      ? (props.state.language === "ma" ? "സജീവം" : "Active")
                      : (props.state.language === "ma" ? "നിഷ്ക്രിയം" : "Inactive")
                    }
                  </span>
                </div>
              </div>


              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "സൃഷ്ടിച്ചത്" : "Created"}
                </label>
                <div className="form-value">
                  {viewUserData.created_at ? new Date(viewUserData.created_at).toLocaleDateString() : 'N/A'}
                </div>
              </div>

              <div className="form-group">
                <label>
                  {props.state.language === "ma" ? "അവസാനം ലോഗിൻ ചെയ്തത്" : "Last Login"}
                </label>
                <div className="form-value">
                  {viewUserData.last_login_at ? new Date(viewUserData.last_login_at).toLocaleDateString() : 'Never'}
                </div>
              </div>

              <div className="form-actions">
                <button
                  type="button"
                  className="btn-cancel"
                  onClick={handleViewClose}
                >
                  {props.state.language === "ma" ? "അടയ്ക്കുക" : "Close"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
